export default "__VITE_ASSET__BObJywst__"